require('whatwg-fetch')

require('core-js/es6/promise')
